// extracted by mini-css-extract-plugin
export default {"errorText":"FormItem_errorText__8llac","inputContainer":"FormItem_inputContainer__-hBYF","labelName":"FormItem_labelName__i5Z9Y"};